module.exports = __webpack_public_path__ + "static/media/mail.db66e610.svg";